import { usersCollection } from "@/firebase";

export enum ACCOUNT_TYPES {
  TEACHER = 1,
  STUDENT = 2
}

export default {
  state: {
    user: { loggedIn: false, data: null, accountType: null }
  },
  getters: {
    user(state: any) {
      return state.user;
    }
  },
  mutations: {
    SET_LOGGED_IN(state: any, value: any) {
      state.user.loggedIn = value;
    },
    SET_USER(state: any, data: any) {
      state.user.data = data;
    },
    SET_ACCOUNT_TYPE(state: any, type?: ACCOUNT_TYPES) {
      state.user.accountType = type;
    }
  },
  actions: {
    fetchUser({ commit, getters }: any, user: any) {
      commit("SET_LOGGED_IN", user !== null);

      if (user) {
        usersCollection
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              let data: any = doc.data();
              let type = data["accountType"];
              let teacherid = null;

              if (type == "teacher") {
                type = ACCOUNT_TYPES.TEACHER;
              } else if (type == "student") {
                type = ACCOUNT_TYPES.STUDENT;
                teacherid = data["teacherid"];
              }
              commit("SET_ACCOUNT_TYPE", type);

              commit("SET_USER", {
                email: user.email,
                uid: user.uid,
                teacherId: teacherid
              });
            }
          });
      } else {
        commit("SET_USER", null);
        commit("SET_ACCOUNT_TYPE", null);
      }
    }
  }
};
